var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.779,
    height: 20.744,
    viewBox: "0 0 19.779 20.744",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-2 {\r\n        fill: none;\r\n        stroke: #7d7d7d;\r\n        stroke-linecap: round;\r\n      }\r\n\r\n      .cls-2 {\r\n        stroke-linejoin: round;\r\n        stroke-miterlimit: 10;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #7d7d7d;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10514",
    "data-name": "Group 10514",
    transform: "translate(-42 -776.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9602",
    "data-name": "Group 9602",
    transform: "translate(42 777)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5319",
    "data-name": "Group 5319",
    transform: "translate(3.867 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7065",
    "data-name": "Path 7065",
    className: "cls-1",
    d: "M20,0H33.105",
    transform: "translate(-18.52 19.744)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_501",
    "data-name": "Path 501",
    className: "cls-2",
    d: "M8.066,14.209,2.983,15.661l1.452-5.083,9.8-9.8a1.8,1.8,0,0,1,2.542,0l1.089,1.089a1.8,1.8,0,0,1,0,2.542Z",
    transform: "translate(-2.983 -0.25)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    "data-name": "Line 2",
    className: "cls-2",
    x1: 3.333,
    y1: 3.333,
    transform: "translate(9.814 2.179)"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1797",
    "data-name": "Ellipse 1797",
    className: "cls-3",
    cx: 1.899,
    cy: 1.899,
    r: 1.899,
    transform: "translate(3.799 20) rotate(180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.420a00d63ff20bab96ecd9305b495658.svg";
export { ForwardRef as ReactComponent };